/**
 * Minimal UI Kit — Custom shadow scale
 * Source: https://github.com/minimal-ui-kit/material-kit-react (free kit, v6.x)
 *
 * 24-step custom shadows — softer and more spread than MUI defaults.
 */

import type { Shadows } from "@mui/material/styles";

const GREY_500 = "#919EAB";

function shadow(opacity: number): string {
  const alpha = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, "0");
  return `0 0 2px 0 ${GREY_500}${alpha}, 0 12px 24px -4px ${GREY_500}${alpha}`;
}

export const minimalShadows: Shadows = [
  "none",
  `0 1px 2px 0 ${GREY_500}40`,
  shadow(0.14),
  shadow(0.16),
  shadow(0.18),
  shadow(0.20),
  shadow(0.22),
  shadow(0.24),
  shadow(0.26),
  shadow(0.28),
  shadow(0.30),
  shadow(0.32),
  shadow(0.34),
  shadow(0.36),
  shadow(0.38),
  shadow(0.40),
  shadow(0.42),
  shadow(0.44),
  shadow(0.46),
  shadow(0.48),
  shadow(0.50),
  shadow(0.52),
  shadow(0.54),
  shadow(0.56),
  shadow(0.58),
];
